module.exports = __webpack_public_path__ + "static/media/16UNODC13.e6a8f04a.jpg";